
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

// Tells the user they have run out of analysis credits. The caller gives the title and the message, since what the
// user needs to hear depends on where it happened.
function QuotaExhaustedModal({title, message, on_close}){

	const [show_modal, set_show_modal] = useState(true);

	const handle_close = ()=>{
		set_show_modal(false);
		on_close();
	};

	return (
		<Modal show={show_modal} onHide={handle_close}>
			<Modal.Header closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<p>{message}</p>

				<Button
					className="modal-cancel-button cancel_button"
					variant="primary"
					type="button"
					onClick={handle_close}>
					Ok
				</Button>
			</Modal.Body>
		</Modal>
	);
}

export default QuotaExhaustedModal;
